module.exports = __webpack_public_path__ + "media/images/logo_siwf_small-d9c3284ca751c4061b71a0aea7baea58.jpeg";